import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=951ceae8&scoped=true"
import script from "./AttributeForm.vue?vue&type=script&lang=js"
export * from "./AttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ceae8",
  null
  
)

export default component.exports